// extracted by mini-css-extract-plugin
module.exports = {"PDFDigitalButton":"styles_PDFDigitalButton__1XEO0","fadeIn":"styles_fadeIn__V5K37"};